/**
 * The on/off switch the Models settings page uses for a provider and for each
 * Model's Allowed cell (task 1147). Same look as the Email & Privacy and
 * Preferences switches; a `role="switch"` button so tests and assistive tech
 * read its state from `aria-checked`.
 */
interface PolicySwitchProps {
  checked: boolean;
  onToggle: () => void;
  label: string;
  disabled?: boolean;
  title?: string;
  testId?: string;
}

export function PolicySwitch({ checked, onToggle, label, disabled = false, title, testId }: PolicySwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      title={title}
      disabled={disabled}
      onClick={onToggle}
      data-testid={testId}
      className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 ${
        checked ? 'bg-indigo-500' : 'bg-zinc-300 dark:bg-zinc-600'
      }`}
    >
      <span
        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform duration-200 ease-in-out ${
          checked ? 'translate-x-5' : 'translate-x-0'
        }`}
      />
    </button>
  );
}
